import { FlexRow } from '@editor/components/utilities/layouts';
import { H6, P3 } from '@repo/ui/components/Typography';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const TabsWrapper = styled(FlexRow)`
  width: 100%;
  border-radius: ${themeStyle.radiusMedium};
  background-color: ${themeStyle.varInkLight};
`;

export const TabsBox = styled(FlexRow)`
  width: 100%;
  height: 100%;
  padding: 1px;
`;

export const Tab = styled(FlexRow)<{
  isActive?: boolean;
  isPlanIntervalTab?: boolean;
}>`
  cursor: pointer;
  align-items: center;
  justify-content: center;
  gap: 8px;
  ${({ isPlanIntervalTab }) =>
    isPlanIntervalTab ? 'padding: 8px 32px;' : 'flex: 1; padding: 8px;'}
  ${({ isActive }) =>
    isActive &&
    `
    background-color: ${themeStyle.varBackgroundAlt};
    border-radius: ${themeStyle.radiusMedium};
  `}
`;

export const TabLabel = styled(H6)<{ isActive?: boolean }>`
  font-size: ${themeStyle.fontSize14};
  text-align: center;
  color: ${({ isActive }) =>
    isActive ? themeStyle.varInkMain : themeStyle.varInkMedium};
`;

export const TabLabelDescription = styled(P3)`
  text-align: center;
  color: ${themeStyle.highlight};
`;
